import { render, staticRenderFns } from "./AntModuleTile.vue?vue&type=template&id=463d7247&scoped=true"
import script from "./AntModuleTile.vue?vue&type=script&lang=js"
export * from "./AntModuleTile.vue?vue&type=script&lang=js"
import style0 from "./AntModuleTile.vue?vue&type=style&index=0&id=463d7247&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463d7247",
  null
  
)

export default component.exports